/**
 * AI Chat Constants
 * Matches backend enums in OrbitalX.Business.Enums.AI
 */
/**
 * Chat message roles (matches ChatMessageRoles in backend)
 */
export const ChatMessageRoles = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant',
    Function: 'function',
};
/**
 * Chat entity types (matches ChatEntityType enum)
 * These represent the type of entity being viewed/edited
 */
export const ChatEntityTypes = {
    None: 'None',
    Campaign: 'Campaign',
    Web: 'Web',
    TouchPoint: 'TouchPoint',
    Asset: 'Asset',
};
/**
 * Chat locations (matches ChatLocation enum)
 * These represent where in the app the user is
 */
export const ChatLocations = {
    CampaignDetails: 'Campaign Details',
    CampaignEditor: 'Campaign Editor',
    CampaignAudience: 'Campaign Audience',
    CampaignWebs: 'Campaign Webs',
    CampaignLeads: 'Campaign Leads',
    CampaignMeetings: 'Campaign Meetings',
    CampaignCalendar: 'Campaign Calendar',
    CampaignAnalytics: 'Campaign Analytics',
    CampaignSettings: 'Campaign Settings',
    WebEditor: 'Web Editor',
    WebDownloadEditor: 'Web Download Editor',
    WebMeetingEditor: 'Web Meeting Editor',
    WebDemoEditor: 'Web Demo Editor',
    WebOnlineEventEditor: 'Web Online Event Editor',
    WebSpeakerEditor: 'Web Speaker Editor',
    WebLeads: 'Web Leads',
    WebMeetings: 'Web Meetings',
    WebCalendar: 'Web Calendar',
    WorkspaceCalendar: 'Workspace Calendar',
    WebAssets: 'Web Assets',
    WebAssetEditor: 'Web Asset Editor',
    WorkspaceSettings: 'Workspace Settings',
    WorkspaceDashboard: 'Workspace Dashboard',
    TouchPointEditor: 'TouchPoint Editor',
    MeetingEditor: 'Meeting Editor',
    LandingPageGenerator: 'Landing Page Generator',
    EmailAssetEditor: 'Email Asset Editor',
    Other: 'Other',
};
/**
 * Chat view modes (matches ChatViewMode enum)
 */
export const ChatViewModes = {
    View: 'View',
    Edit: 'Edit',
    Create: 'Create',
};
